import styled from 'styled-components';

// Container for the profile settings section, designed to blend into a settings menu
export const ProfileSettingsContainer = styled.div`
    padding: 15px 20px; // Consistent with SidebarContent padding or MenuItem
    background-color: transparent; // Blend with parent menu background
    color: #B6C2CF; // Default text color from settings menu

    h4 { // Changed from h3 for potentially less emphasis, or adjust as needed
        margin-top: 0;
        margin-bottom: 15px;
        color: #B6C2CF; // Match HeaderTitle or general text color
        font-size: 15px; // Slightly smaller or match existing headers
        font-weight: 600;
    }

    form {
        display: flex;
        flex-direction: column;
        gap: 12px; // Slightly reduced gap
    }

    label {
        font-weight: 500; // Less bold, more subtle
        margin-bottom: 4px;
        font-size: 13px; // Match general text size
        color: #8C9BAB; // Subtler label color like MenuItem span
    }

    input[type="text"] {
        padding: 8px 10px; // Match other input fields if any, or a bit less padding
        border: 1px solid #3B444C; // Border color from settings menu
        background-color: #22272B; // Darker background for input
        color: #B6C2CF; // Text color for input
        border-radius: 3px; // Consistent border-radius
        font-size: 14px;
        width: 100%;
        box-sizing: border-box;

        &:focus {
            border-color: #007bff; // Highlight focus, or use a color from the app's theme
            outline: none;
        }
    }

    button[type="submit"] {
        padding: 8px 12px;
        background-color: #007bff; // Primary action color (can be themed)
        color: white;
        border: none;
        border-radius: 3px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        transition: background-color 0.2s ease-in-out;
        margin-top: 5px; // Add some space before the button

        &:hover {
            background-color: #0056b3; // Darker shade on hover
        }

        &:disabled {
            background-color: #3B444C; // Disabled state matches other UI elements
            color: #8C9BAB;
            cursor: not-allowed;
        }
    }

    p.message { // Class for messages
        text-align: left; // Align with form fields
        padding: 8px 10px;
        border-radius: 3px;
        margin-top: 0;
        margin-bottom: 10px; // Space it out before the form or at the top
        font-size: 13px;
    }

    p.success-message {
        background-color: rgba(40, 167, 69, 0.2); // More subtle success green
        color: #28a745;
        border: 1px solid rgba(40, 167, 69, 0.4);
    }

    p.error-message {
        background-color: rgba(220, 53, 69, 0.2); // More subtle error red
        color: #dc3545;
        border: 1px solid rgba(220, 53, 69, 0.4);
    }
`;

export const StyledFileInputLabel = styled.label`
    display: inline-block;
    padding: 8px 12px;
    background-color: #007bff; // Primary action color, same as submit button
    color: white !important; // Enforce white color in all states
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    transition: background-color 0.2s ease-in-out;
    margin-top: 5px; // Consistent with submit button margin

    &:hover {
        background-color: #0056b3; // Darker shade on hover
    }

    /* Style for when the actual input is focused, apply to the label */
    input[type="file"]:focus + & {
        outline: 1px dotted #000; /* Or some other focus style */
        outline: -webkit-focus-ring-color auto 5px;
    }
`;

export const HiddenFileInput = styled.input`
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
`;

// Wrapper for ProfileSettings when inside UserSettingsMenu to control padding
export const ProfileSettingsWrapper = styled.div`
    padding: 0; /* Remove padding for the wrapper */

    /* Specific adjustments for ProfileSettingsContainer if needed when inside this wrapper */
    ${ProfileSettingsContainer} {
      padding-top: 0;
    }
`;

// Wrapper for the form field (label + input)
export const FormField = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ProfilePictureContainer = styled.div`
    margin-bottom: 10px;
    display: flex;
    justify-content: center; // Center the image preview
    align-items: center;
`;

export const ProfilePicturePreview = styled.img`
    width: 100px; // Adjust size as needed
    height: 100px; // Adjust size as needed
    border-radius: 50%; // Make it circular
    object-fit: cover; // Ensure the image covers the area without distortion
    border: 2px solid #3B444C; // Optional: adds a border similar to input fields
`;

// This BackButton might be used in UserSettingsMenu.js instead,
// but styled here for consistency if placed within ProfileSettings.
export const BackButton = styled.button`
    background: none;
    border: none;
    color: #007bff; // Action color, can be inherited or set to match icon color preference
    cursor: pointer;
    /* font-size removed as it's an icon now */
    padding: 8px 0px;
    display: flex;
    align-items: center;

    &:hover {
        /* text-decoration: underline; */ /* Not needed for icon button */
        opacity: 0.7; /* Example hover effect for icon */
    }

    svg {
        /* margin-right: 5px; */ /* Not needed if there's no text next to it */
        stroke: #007bff; /* Ensure icon color matches if not inherited */
        width: 20px; /* Adjust size as needed */
        height: 20px; /* Adjust size as needed */
    }
`;

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    
    h3 {
        margin: 0;
        color: #B6C2CF;
        font-size: 15px;
        font-weight: 600;
    }
`;
